import { GraphData, graphId, layoutGraph } from './graph-model';

/** Use the same measured node widths and automatic coordinates in Design and lesson views. */
export function createGraphSvg(doc: Document, graph: GraphData, interactive = false): SVGSVGElement {
    const element = (name: string, attributes: Record<string, string | number>) => {
        const result = doc.createElementNS('http://www.w3.org/2000/svg', name);
        Object.entries(attributes).forEach(([key, value]) => result.setAttribute(key, String(value)));
        return result;
    };
    const { positions, width, height } = layoutGraph(graph);
    const svg = element('svg', { viewBox: `0 0 ${width} ${height}`, role: 'img', 'aria-label': 'Graph preview' }) as SVGSVGElement;
    svg.style.cssText = 'display:block;width:100%;height:auto;';
    graph.edges.forEach(edge => {
        const start = positions.get(graphId(edge.from))!, end = positions.get(graphId(edge.to))!;
        const d = `M ${start.x} ${start.y + 25} C ${start.x} ${start.y + 90}, ${end.x} ${end.y - 90}, ${end.x} ${end.y - 25}`;
        svg.appendChild(element('path', { d, fill: 'none', stroke: 'var(--text-color-secondary,#666)', 'stroke-width': 2 }));
    });
    graph.nodes.forEach(node => {
        const pos = positions.get(graphId(node.id))!;
        const group = element('g', { transform: `translate(${pos.x}, ${pos.y})`, 'data-graph-node-id': graphId(node.id) });
        if (interactive) {
            group.setAttribute('class', 'graph-node');
            group.setAttribute('role', 'button');
            group.setAttribute('tabindex', '0');
            group.setAttribute('aria-label', node.title || node.label);
        }
        group.appendChild(element('rect', { class: 'node-rect', x: -pos.width / 2, y: -25, width: pos.width, height: 50, rx: 12,
            fill: 'var(--surface-card,#fff)', stroke: 'var(--primary-color,#3b82f6)', 'stroke-width': 2 }));
        const text = element('text', { 'text-anchor': 'middle', y: 5, fill: 'var(--text-color,#333)', 'font-size': 13, 'font-family': 'sans-serif', 'font-weight': 600 });
        // Labels are text, never markup or inline JavaScript.
        text.textContent = (node.icon ? node.icon + ' ' : '') + (node.title || node.label || '(No label)');
        group.appendChild(text);
        svg.appendChild(group);
    });
    return svg;
}
